import { MasterBsiManager } from '@wix/bsi-manager/dist/src/manager-master'
import { BrowserWindow } from '@wix/thunderbolt-symbols'
import { IConsentPolicy } from 'feature-consent-policy'

const generateGuid = () =>
	'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(e) {
		const i = (16 * Math.random()) | 0
		return ('x' === e ? i : (3 & i) | 8).toString(16)
	})

export const createMasterBsiManager = (window: BrowserWindow, consentPolicy: IConsentPolicy) =>
	new MasterBsiManager().init({
		genGuid: generateGuid,
		getCommonConfig: () => window && (window as any).commonConfig,
		getConsentPolicy: () => consentPolicy.getCurrentConsentPolicy(),
	})
